export enum LocalStorageKeys {
  EMAIL = 'email',
  PODCAST_PLAYBACK = 'beehiiv:podcast-playback',
}
